// extracted by mini-css-extract-plugin
module.exports = {"Set":"Social_Set__Huq4T","Item":"Social_Item__Sxwoo"};